import { combineReducers } from 'redux';
import { authReducer } from '../auth';
import { httpRequestsOnLoadReducer } from '../http_requests_on_load';
import { httpRequestsOnSuccessReducer } from '../http_requests_on_success';
import { httpRequestsOnErrorsReducer } from '../http_requests_on_errors';
import { questionsReducer } from '../questions';
import { settingsReducer } from '../settings';
import { popularDestinationsReducer } from '../popularDestinations';
import { offersReducer } from '../offers';
import { suggestionReducer } from '../suggestions';

export const appReducer = combineReducers({
  auth: authReducer,
  questions: questionsReducer,
  settings: settingsReducer,
  httpOnLoad: httpRequestsOnLoadReducer,
  httpOnSuccess: httpRequestsOnSuccessReducer,
  httpOnError: httpRequestsOnErrorsReducer,
  popularDestination: popularDestinationsReducer,
  offersReducer: offersReducer,
  suggestionReducer: suggestionReducer,
});
